<template>
  <div>
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-sm-12 col-md-12 col-xl-12">
              <h4 class="card-title">
                Values
                <router-link
                  v-show="isAdministrator"
                  class="btn btn-sm btn-primary float-right"
                  :to="{ name: 'ValueCreate' }"
                  >Create
                </router-link>
              </h4>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-3 col-xl-3">
              <input
                type="text"
                id="searchCode"
                placeholder="Search Code"
                class="form-control"
                v-model="search.code"
              />
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <input
                type="number"
                id="searchYear"
                placeholder="Search Year"
                class="form-control"
                v-model="search.year"
              />
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <vue-select
                id="selectLimit"
                name="selectLimit"
                class="form-control"
                placeholder="--- Select namespace ---"
                v-model="search.namespace"
                :options="search.namespaces"
                close-on-select
                :empty-model-value="null"
              ></vue-select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-3 col-xl-3">
              <div class="form-group" data-children-count="1">
                <label class="">Limit</label>
                <vue-select
                  id="selectLimit"
                  name="selectLimit"
                  class="form-control"
                  v-model="pagination.limit"
                  :options="pagination.limits"
                  close-on-select
                ></vue-select>
              </div>
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <label for="page" class="">Current Page</label
              ><input
                id="page"
                placeholder="Page"
                min="0"
                :max="pagination.pages"
                type="number"
                class="form-control"
                v-model="pagination.page"
              />
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <label for="pages" class="">Pages</label
              ><input
                id="pages"
                readonly=""
                type="number"
                class="form-control"
                v-model="pagination.pages"
              />
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3">
              <label for="total" class="">Total</label
              ><input
                id="total"
                readonly=""
                type="number"
                class="form-control"
                v-model="pagination.total"
              />
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-1 col-xl-1"
            >
              NAMESPACE
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
            >
              CODE
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
            >
              YEAR
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
            >
              TRADE PRICE
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
            >
              RETAIL PRICE
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
            >
              NEW PRICE
            </div>
            <div
              class="border-top border-bottom p-1 col-sm-2 col-md-1 col-xl-1"
            >
              <span class="float-right">ACTION</span>
            </div>
          </div>

          <div v-for="value in values" :key="`${value.id}`">
            <div class="row">
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-1 col-xl-1"
              >
                {{ value.namespace }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
              >
                {{ value.code }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
              >
                {{ value.year }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
              >
                {{ value.trade_price }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
              >
                {{ value.retail_price }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-12 col-md-2 col-xl-2"
              >
                {{ value.new_price }}
              </div>
              <div
                class="border-top border-bottom p-1 col-sm-2 col-md-1 col-xl-1"
              >
                <div role="group" class="float-right btn-group">
                  <router-link
                    v-if="value.is_import === 0"
                    class="btn btn-success btn-sm"
                    :to="{ name: 'ValueEdit', params: { id: value.id } }"
                    >Edit</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">Footer</div>
      </div>
    </div>
  </div>
</template>

<script>
import { namespaceList } from "../../controllers/data-contoller";
import { getValues } from "../../controllers/value-contoller";
import { mapGetters } from "vuex";

export default {
  data: () => {
    return {
      search: {
        code: null,
        year: null,
        namespace: null,
        namespaces: namespaceList,
      },
      pagination: {
        limit: 10,
        page: 1,
        limits: [1, 5, 10, 15, 50, 100],
        pages: 1,
        total: 0,
      },
      values: [],
    };
  },
  computed: {
    ...mapGetters(["isAdministrator"]),
  },
  created() {
    try {
      this.updateValue();
    } catch (e) {
      console.log(e);
    }
  },
  watch: {
    search: {
      deep: true,
      handler() {
        this.updateValue();
      },
    },
    "pagination.limit"() {
      this.updateValue();
    },
    "pagination.page"() {
      this.updateValue();
    },
  },
  methods: {
    updateValue() {
      setTimeout(async () => {
        const { values, pagination } = await getValues(
          this.search,
          this.pagination
        );
        this.values = values;
        this.pagination.total = pagination.total;
        this.pagination.pages = pagination.lastPage;
      }, 50);
    },
  },
};
</script>
